import { useMutation } from '@tanstack/react-query'

import { photobookApi, type PhotobookGeneratePayload } from '@/utils/api/photobook'

/**
 * Génère un PDF photobook et déclenche le téléchargement navigateur.
 *
 * Pas d'invalidation TanStack (génération pure → pas de mutation DB).
 * Le caller reçoit `{ mutate, isPending, error }` standard mutation —
 * idéal pour piloter un bouton "Générer" avec spinner + désactivation.
 */
export function useGeneratePhotobook() {
  return useMutation<Blob, Error, PhotobookGeneratePayload>({
    mutationFn: (payload) => photobookApi.generate(payload),
    onSuccess: (blob) => {
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      const today = new Date().toISOString().slice(0, 10)
      a.href = url
      a.download = `sgraphic-catalogue-${today}.pdf`
      document.body.appendChild(a)
      a.click()
      a.remove()
      // Libère le blob après que le navigateur ait pris le téléchargement
      // (le download lit l'URL de façon synchrone, on peut révoquer ensuite).
      setTimeout(() => URL.revokeObjectURL(url), 1000)
    },
  })
}
